import React from 'react';
import './spinner.css';

export const Spinner = () => {
    return React.createElement("div", { className: "spinner" })
}

export const SpinnerContainer = () => {
    return (
        React.createElement("div", { className: 'spinnerContainer' },
            React.createElement(Spinner, null)
        )
    )

}